/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React from "react";
import { Container } from "react-bootstrap";
import styles from "./index.module.css";
import parse from "html-react-parser";

const RatesSection = ({ links, angelAiLink, sunwestLink }) => {
  return (
    <>
    {links ? (
    <Container fluid className={styles.rates_info_section}>
      <p className={`${styles.max_width_limit} ${styles.mb_small}`}>
        <div className={styles.mb_small}>
          Become a {sunwestLink ? parse(sunwestLink) : 'Sun West'} Loan Originator and ditch your average loan officer
          commission. {sunwestLink ? parse(sunwestLink) : 'Sun West'} offers amazing pricing with Approval on demand and condition review on demand.{" "}
        </div>
        <div className={styles.mb_small}>
          Our exclusive{" "}
          {angelAiLink ? parse(angelAiLink) : links.current.brandName}<sup className={styles.tm}>TM</sup>
          {" "}technology eliminates the need for multiple layers between your branch
          and the {sunwestLink ? parse(sunwestLink) : 'Sun West'} executive management. That cost savings is passed on
          to your branch in the form of excellent pricing.
          {" "}{angelAiLink ? parse(angelAiLink) : links.current.brandName}{" "}
          Technology + No Layers = Fast Decisions, Fast Answers, and Fast
          Closings.
        </div>
        <div className={styles.mb_small}>
          Our Partner model scales to any size branch from one originator to
          hundreds of originators. Design your own pricing plan with your choice
          of compensation that can exceed 300&nbsp;bps. Partners get access to{" "}
          {angelAiLink ? parse(angelAiLink) : links.current.brandName}
          , {sunwestLink ? parse(sunwestLink) : 'Sun West'} proprietary &amp; patented retail technology.
        </div>
      </p>
      </Container>
      ) : (
        'Loading...'
      )}
    </>
  );
};

export default RatesSection;
